module.exports = __webpack_public_path__ + "static/media/logo3.1ddda078.jpg";